export default function Popup (props){
    return (
    props.show ? <div className='popup' >
        {
            props.children
        }
    </div> : null
    );
}